const bhiveDomain = 'https://bhivebonlinep2.wordpress.com';
const freshdeskTicketsDomain = process.env.VUE_APP_FRESHDESK_TICKETS_URL || 'https://bonlineltdsandbox.freshdesk.com/a/tickets';
const myBonlineDomain = process.env.VUE_APP_MY_BONLINE_DOMAIN || 'https://mybonline.bonline-testing.xyz/';

const articleLinks = {
  numbersVoip: `${bhiveDomain}/troubleshooting-and-guides/crm/numbers-voip/`,
  transferNumberDialog: `${bhiveDomain}/processes-and-workflows/voip/placing-a-post-live-port/`,
  availabilityTelco: `${bhiveDomain}/troubleshooting-and-guides/crm/availability-telco/`,
  lineTelco: `${bhiveDomain}/troubleshooting-and-guides/crm/line-telco/`,
  provisioningTelco: `${bhiveDomain}/troubleshooting-and-guides/provisioning-telco/`,
  users: `${bhiveDomain}/troubleshooting-and-guides/crm/users/`,
  numberTransfers: `${bhiveDomain}/troubleshooting-and-guides/crm/number-transfers/`,
  productVoip: `${bhiveDomain}/troubleshooting-and-guides/crm/product-level/`,
  tickets: `${bhiveDomain}/troubleshooting-and-guides/crm/crm-tickets/`,
  account: `${bhiveDomain}/troubleshooting-and-guides/crm/account-level/`,
  dashboard: `${bhiveDomain}/troubleshooting-and-guides/crm/dashboard/`,
}

const links = {
  availabilityCheckerTesting: 'https://mybonline.bonline-testing.xyz/broadband-availability'
}

export {
  articleLinks,
  links,
  freshdeskTicketsDomain,
  myBonlineDomain,
}
